import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'craving_times'

const OPTIONS = [
  {
    value: 'in-the-morning',
    translationKey: 'pages.onboarding.cravingTimes.options.in-the-morning',
  },
  {
    value: 'when-im-stressed',
    translationKey: 'pages.onboarding.cravingTimes.options.when-im-stressed',
  },
  {
    value: 'when-im-bored',
    translationKey: 'pages.onboarding.cravingTimes.options.when-im-bored',
  },
  {
    value: 'after-meals',
    translationKey: 'pages.onboarding.cravingTimes.options.after-meals',
  },
  {
    value: 'social-situations',
    translationKey: 'pages.onboarding.cravingTimes.options.social-situations',
  },
  {
    value: 'at-night',
    translationKey: 'pages.onboarding.cravingTimes.options.at-night',
  },
]

const ANSWER_TEXTS = {
  'in-the-morning': 'In the morning',
  'when-im-stressed': "When I'm stressed",
  'when-im-bored': "When I'm bored",
  'after-meals': 'After meals',
  'social-situations': 'Social situations',
  'at-night': 'At night',
}

export default function CravingTimesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'When are your cravings strongest?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.cravingTimes.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
